<template>
  <div class="grid h-screen m-auto mainDiv">
    <div class="col-12 md:col-6 lg:col-6 bg-white containerDiv">
      <div class="flex h-full flex-column justify-content-between">
        <div class="header">
          <div class="languageBtn">
            <languageDDL :mainColor="1"></languageDDL>
          </div>
          <Button
            v-if="routerName != 'landingpage'"
            :label="backBtnLabel"
            class="btnClass"
            style="padding: 5px 10px !important; margin: 0px 20px !important"
            @click="backFn"
          />
        </div>

        <div class="navigatorDiv" style="padding: 20px !important">
          <router-view></router-view>
        </div>

        <div class="footer">
          <!-- <span class="infoLinkSpan">{{ $t("Privacy_Policy") }}</span> -->
          <!-- <span class="infoLinkSpan">{{ $t("Terms_Conditions") }}</span> -->
          <a
            href="https://drive.google.com/drive/folders/114v8mJiHRDN3X7c3DXDMZhhquDOpuDmp?usp=sharing"
            target="_blank"
            class="infoLinkSpan"
            >{{ $t("HowToUSe") }}</a
          >
          <span class="infoLinkSpan" @click="showDialog">{{
            $t("Terms_Conditions")
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="col-12 md:col-6 lg:col-6 h-25rem md:h-screen lg:h-screen flex flex-column justify-content-center logoContainer"
    >
      <img src="../assets/images/azharLogo_vertical.png" class="logoImg" />
      <div class="systemName">منصة الأزهر للوافدين</div>
      <div class="systemName">International Students Gate</div>
    </div>
  </div>
</template>

<script>
import languageDDL from "../components/shared-components/langueButton.vue";
import { Dialog } from "primevue/dialog";

export default {
  data() {
    return {
      dialogVisible: false,

      termsAndConditions: `
        <p>
        <span>
          اوافق والتزم بجميع شروط واجراءات وقواعد قبول الطلاب الوافدين بجامعة
          الازهر <br />
          - التزم بكافة الشروط وقواعد قبول الجامعة <br />
          - التزم بجميع الشروط والضوابط المنظمة للالتحاق بالبرامج الدراسية في
          جميع كليات جامعة الازهر <br />
          - اقر بان البيانات المدخلة صحيحة وان بيانات الدفع الالكتروني البنكية
          صحيحة <br />
          - التزم بتحميل صور واضحة من الاوراق الاتية ( صورة شخصية - الشهادة
          الثانوية - تضاف شهادة القدرات بالنسبة للثانوية السعودية - جواز سفر
          ساري العمل به مدة لا تقل عن ستة اشهر من تاريخ التقديم ) علي ان تكون
          جميع المستندات بنفس الاسم <br />
          - التزم عند التسجيل اذا كانت الام مصرية اقوم بتوضيح ذلك ويجب تحميل ما
          يثبت ذلك (شهادة ميلاد المتقدم - بطاقة الرقم القومي للام ) <br />
          - اقر بتحمل المسؤلية الكاملة عن اختيار رغباتي <br />
          - التزم بسداد المصروفات الدراسية طبقا لما تنص عليه قواعد ولوائح الطلاب
          الوافدين بجامعة الازهر <br />
          - اقر والتزم بان ترشيحي للكلية يعد ترشيحا مبدئيا ولا يعد ترشيح نهائي
          الا بعد تقديم الاوراق مطابقة لما تم تقديمه علي الموقع الالكتروني
          معتمدة وموثقة من الجهات المختصة <br />
          - اوافق علي الالتزام بموعيد تقديم اصول الاوراق كاملة واقر بصحة
          البيانات المقدمة وصحة الشهادة و جواز السفر واتحمل المسؤلية الكاملة في
          حالة تقديم اوراق مخالفة لما تم تقديمها علي الموقع الالكتروني والا
          سيكون ترشيحي لاغيا ولا يحق لي المطالبة بتنفيذه <br />
          - اوافق علي الغاء ترشيحي في حالة اعتراض الجهات المختصة علي ترشيحي في
          اي وقت يصبح ترشيحي لاغيا <br />
          - اتعهد بعدم المطالبة باسترداد المقابل النقدي للخدمات المقدمة علي
          الموقع الالكتروني <br />
          - اوافق علي ان يتم الغاء التسجيل اذا تقدمت اكثر من مرة او قدمت مستندات
          غير صحيحة او غير مكتملة. <br />
          اتعهد ان البيانات التي قمت بادخالها على الموقع صحيحة وان الأوراق
          الموجودة على الموقع مطابقة للأوراق الاصلية الخاصة بي. <br />
          أتعهد بأن احترم أنظمة ولوائح الكلية و التعليمات التي تصدرها إدارة
          الكلية وان اكون قدوة حسنة للسلوك الامثل وان اكون محافظا على الحضور
          اليومي للدراسة و مواظبا على ذلك وفق الجدول الخاص بالكلية، و ان اقوم
          بالاعمال التي اكلف بها من قبل المعلمين و الادارة، وان احافظ على
          ممتلكات الكلية، و في حالة عدم التزامي بذلك اتعهد بدفع جميع التكاليف.
          <br />
          اتعهد باننى غير مقيدا ولا مرشحا باى كلية من كليات جامعة الازهر. واننى
          لم يسبق لى الدراسة او الحصول على مؤهل من جامعة الازهر. في حالة وجود اى
          ما يخالف ذلك أوافق على الغاء ترشيحى ولا يحق لى مطالبة الجامعة باية
          مصروفات او رسوم قمت بسددها. <br />
          وفي حالة قيامى بسحب الملف وعدم استكمال الإجراءات لايحق يحق لى مطالبة
          الجامعة باية مصروفات او رسوم دراسية قمت بسددها.
        </span>
        <br />
        <br />
        <span style="direction: ltr; text-align: left; display: block">
          I agree and commit to all the conditions, procedures, and rules for
          accepting foreign students at Al-Azhar University<br />
          - I commit to all the conditions and admission rules of the
          university<br />
          - I commit to all the regulations and requirements for enrolling in
          study programs in all faculties of Al-Azhar University<br />
          - I acknowledge that the entered data is correct and that the
          electronic bank payment information is accurate<br />
          - I commit to uploading clear photos of the following documents
          (personal photo, high school certificate, the Qudurat certificate for
          Saudi high school, a valid passport for a period of not less than six
          months from the date of application), and all documents should be
          under the same name<br />
          - Upon registration, I commit to clarifying if my mother is Egyptian
          and must provide proof (applicant's birth certificate, national ID
          card for the mother)<br />
          - I acknowledge full responsibility for my choice of preferences<br />
          - I commit to paying the tuition fees in accordance with the rules and
          regulations for foreign students at Al-Azhar University<br />
          - I acknowledge and commit that my nomination for the college is
          preliminary and is not final until the submitted documents are
          verified on the official website and authenticated by the competent
          authorities<br />
          - I agree to comply with the deadline for submitting all the original
          documents and acknowledge the accuracy of the information provided,
          the validity of the certificate, and the passport. I also assume full
          responsibility in case of submitting documents that contradict what
          was submitted on the official website, otherwise, my nomination will
          be canceled, and I will not be entitled to demand its
          implementation<br />
          - I agree to cancel my nomination if the competent authorities object
          to my nomination at any time, my nomination will be canceled<br />
          - I undertake not to claim a refund for the cash payment for the
          services provided on the official website<br />
          - I agree that registration will be canceled if I apply more than once
          or if I submit incorrect or incomplete documents.<br />
          I pledge that the data I entered on the website is correct and that
          the documents on the website match my original documents.<br />
          I undertake to respect the college's regulations and rules, as well as
          the instructions issued by the college administration. I pledge to set
          a good example of proper conduct and to maintain daily attendance in
          accordance with the college timetable. I also commit to carrying out
          any tasks assigned to me by teachers and the administration, and to
          preserve the college's property. In the event of non-compliance, I
          agree to pay all costs.<br />
          I pledge that I am not enrolled or nominated in any college of
          Al-Azhar University, and I have not previously studied or obtained a
          qualification from Al-Azhar University. If there is any violation of
          this, I agree to cancel my nomination and I shall not have the right
          to claim any fees or expenses I have paid to the university.<br />
          If I withdraw my file and do not complete the procedures, I shall not
          have the right to claim any fees or tuition expenses I have paid.
        </span>
      </p>
      `,
    };
  },
  components: { languageDDL, Dialog },
  mounted() {},
  computed: {
    backBtnLabel() {
      return this.$t("back");
    },
    routerName() {
      return this.$route.name;
    },
  },
  methods: {
    backFn() {
      this.$router.push("/");
    },
    showDialog() {
      this.$swal.fire({
        title: "Terms and Conditions",
        html: this.termsAndConditions,
        confirmButtonText: "Close",
        showCancelButton: false,
        showCloseButton: true,
      });
    },
  },
};
</script>

<style scoped>
.btnClass {
  background-color: #028bff;
  color: #ffffff;
  padding: 10px 20px !important;
  margin: 0px 20px;
  font-weight: bold;
}

:deep(.p-placeholder) {
  text-align: start !important;
}

:deep(.p-dropdown-label) {
  text-align: start !important;
}

:deep(.p-dropdown-label) {
  color: var(--main-color) !important;
  font-weight: bold;
}

:deep(.p-dropdown-trigger-icon) {
  color: var(--main-color) !important;
  font-weight: bold;
}

:deep(.p-dropdown) {
  border-color: transparent;
  box-shadow: 1px 1px 6px #d5cfcf;
}

:deep(.p-inputtext) {
  color: var(--main-color) !important;
  font-weight: bold;
  border-radius: 10px;
}

.mainDiv {
  background-image: url("../assets/images/islamicTextureBg.png");
  background-size: cover;
}

.containerDiv {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 30px #00000012;
  border-radius: 0px 20px 20px 0px;
}

.logoContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0 3rem;
}

.logoImg {
  width: 25vh;
  width: 25vh;
  margin: 10px auto;
}

.systemName {
  font-size: 1.5rem;

  font-weight: bold;
  font-family: "Cairo";
  text-align: center;
}

.header {
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
}

.infoLinkSpan {
  text-align: center;
  text-decoration: underline;
  letter-spacing: 0px;
  color: #028bff;
  text-transform: capitalize;
  margin: 5px 10px;
  cursor: pointer;
}

.footer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: center;
}

.logoContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.navigatorDiv {
  padding: 20px !important;
}

.languageBtn {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
